const { PCP_LENDERS, isVehiclePcpEligible } = require("../calculator-constants");
const { mockAlpheraProposal, mockBnpProposal, mockCloseProposal, mockZopaProposal, mockMotonovoProposal } = require("../mocks");
const { mockCaProposal } = require("../mocks/mock-ca-proposal");
const { mockNorthridgeProposal } = require("../mocks/mock-northridge-proposal");
const { mockV12Proposal } = require("../mocks/mock-v12-proposal");
const { vehicleService } = require("../services/vehicle-service");

async function constructResidualsRequest(vehicle, deposit = 0, proposals = null, terms = null, annualMileage = 8000, updatedMileage = null, capCode = null) {

    try {
        // For mocking / quick quoting / anonymous pricing
        if (!proposals || !Array.isArray(proposals) || proposals.length === 0){
            proposals = [
                mockAlpheraProposal(vehicle.price),
                mockCloseProposal(vehicle.price),
                mockZopaProposal(vehicle.price),
                mockMotonovoProposal(vehicle.price),
                mockCaProposal(vehicle.price),
                mockV12Proposal(vehicle.price),
                mockNorthridgeProposal(vehicle.price),
            ]
        }

        // Vehicle eligibility
        const isPcpEligible = isVehiclePcpEligible({...vehicle, mileage: updatedMileage ? updatedMileage : vehicle.mileage }, proposals);

        if (!isPcpEligible) {
            return null;
        }

        // Customer eligibility
        const pcpApproved = proposals.find(p => PCP_LENDERS.includes(p.financeCompanyId) && (!p.customerRuleResults || (p.customerRuleResults.find(rr => rr.resultType === "FixedDecline") ? p.loanProposalStatus === "Accepted" ? true : false : true)) && (p.loanProposalStatus === "Accepted" || p.loanProposalStatus === "ProvisionalAcceptance" || p.loanProposalStatus == "ConditionallyAccepted")) ? true : false;

        if (!pcpApproved) {
            return null;
        }

        // So many different ways to store a VRM... Needs fixing
        const vrm = vehicle.vrm || vehicle.vehicleRegistration || vehicle.regNumber || vehicle.registration;

        if(!vrm && !capCode){
            return null;
        }

        let capVehicle;

        if (!capCode || (!vehicle.registrationDate && !vehicle.vehicleDateOfFirstReg)) {
            // Correct cap code is critical for correct residuals
            capVehicle = await vehicleService.vehicleLookup(vrm);

            if(!capVehicle.price){
                capVehicle.price = vehicle.price;
            }

            if (!capVehicle.capCode) {
                return null;
            }

            capVehicle.mileage = updatedMileage ? updatedMileage : (vehicle.mileage || 0);
        }

        // Assess lenders to request residuals from
        const hasAlpheraProp = proposals.find(p => p.financeCompanyId === 50 && isApproved(p)) ? true : false;
        const hasCloseProp = proposals.find(p => p.financeCompanyId === 70 && isApproved(p)) ? true : false;
        const hasZopaProp = proposals.find(p => p.financeCompanyId === 73 && isApproved(p)) ? true : false;
        const hasBnpProp = proposals.find(p => p.financeCompanyId === 63 && isApproved(p)) ? true : false;
        const hasMotonovoProp = proposals.find(p => p.financeCompanyId === 67 && isApproved(p)) ? true : false;
        const hasCaProp = proposals.find(p => p.financeCompanyId === 74 && isApproved(p)) ? true : false;
        const hasV12Prop = proposals.find(p => p.financeCompanyId === 66 && isApproved(p)) ? true : false;
        const hasNorthridgeProp = proposals.find(p => p.financeCompanyId === 75 && isApproved(p)) ? true : false;

        const toGet = [];

        hasBnpProp ? toGet.push(63) : null;
        hasAlpheraProp ? toGet.push(50) : null;
        hasCloseProp ? toGet.push(70) : null;
        hasZopaProp ? toGet.push(73) : null;
        hasMotonovoProp ? toGet.push(67) : null;
        hasCaProp ? toGet.push(74) : null;
        hasV12Prop ? toGet.push(66) : null;
        hasNorthridgeProp ? toGet.push(75) : null;
        
        const currentMileage = capVehicle ? capVehicle.mileage : updatedMileage ? updatedMileage : vehicle.mileage;
        const currentRegistrationDate = capVehicle ? capVehicle.vehicleDateOfFirstReg : (vehicle.registrationDate || vehicle.vehicleDateOfFirstReg);

        // Build request object
        const request = {
            financeCompanyResidualSetting: toGet.map(t => {
                return {
                    financeCompanyId: t,
                    residualValueRequestType: 3 //LenderEndpointThenLocalFile
                }
            }),
            terms: terms ? terms : [24, 36, 48, 60],
            price: capVehicle ? capVehicle.price : parseInt(vehicle.price),
            registrationDate: new Date(currentRegistrationDate).toJSON(),
            registration: capVehicle ? capVehicle.vrm : vrm,
            make: capVehicle ? capVehicle.make : vehicle.make,
            model: capVehicle ? capVehicle.model : vehicle.model,
            capCode: capVehicle ? capVehicle.capCode : capCode,
            capId: capVehicle ? capVehicle.capId : vehicle.capId,
            vehicleType: 1,
            deposit,
            mileage: parseInt(currentMileage),
            annualMileage: annualMileage,
            isNew: false,
            vin: capVehicle ? capVehicle.vin : vehicle.vin
        }

        return request;
    }
    catch (error) {
        return null;
    }
}

function isApproved(prop){
    return prop.loanProposalStatus === "Accepted" 
    || ( 
        (prop.loanProposalStatus === "ProvisionalAcceptance" || prop.loanProposalStatus === "ConditionallyAccepted" ) 
        && (!prop.customerRuleResults || !prop.customerRuleResults.find(r => r.resultType === "FixedDecline") ) 
    )
}

module.exports = {
    constructResidualsRequest
}
